export default __webpack_public_path__ + "static/media/icon_academic_education.7daa9e52.svg";